import { useTable, useFlexLayout, usePagination, type Column } from 'react-table';
import { Card, CardContent, GroupCardHeader } from '@trinity/chat-components/components/presentation/Main/index.js';
import { GroupTable, GroupTableFooter } from '@/components/presentation/GroupTable';
import { AnimatedLoader } from '@trinity/chat-components/components/presentation/AnimatedLoader.js';
import ViewAll from './ViewAll';
import type { QuantAnalysesTableItem } from './interfaces';
import styles from './style/Table.module.css';
import { useQuantAnalysesTableColumns } from './hooks';

type Props = {
  data: QuantAnalysesTableItem[];
  countText: string;
  pagination?: boolean;
  pageSize: number;
  isLoading: boolean;
  viewAll?: boolean;
};

export default function SearchTableQuantAnalyses({ data, countText, pagination, pageSize, isLoading, viewAll }: Props) {
  const columns = useQuantAnalysesTableColumns() as Column<QuantAnalysesTableItem>[];

  const tableInstance = useTable<QuantAnalysesTableItem>(
    {
      columns,
      data,
      initialState: {
        pageIndex: 0,
        pageSize,
      },
    },
    useFlexLayout,
    usePagination,
  );

  const tableClasses = {
    body: styles.body,
    td: styles.td,
    tr: styles.tr,
  };

  const footerClasses = {
    root: styles.footer,
    pageSize: styles.rows,
  };

  return (
    <Card className={styles.card}>
      <GroupCardHeader className={styles.header}>
        <div className={styles.left}>
          <div>Analysis<span className={styles.count}>{countText}</span></div>
        </div>
        {viewAll && (
          <div className={styles.right}>
            <ViewAll tab="quantanalyses" />
          </div>)}
      </GroupCardHeader>
      <CardContent className={styles.content} fluid>
        {!isLoading && !!data.length &&
          <GroupTable
            classes={tableClasses}
            instance={tableInstance} />}
        {isLoading && (<AnimatedLoader className={styles.loading} />)}
        {!isLoading && pagination && !!data.length &&
          <GroupTableFooter
            classes={footerClasses}
            instance={tableInstance} />}
      </CardContent>
    </Card>
  );
}

export { SearchTableQuantAnalyses };